import produce from 'immer'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import {
  indicatorResponse
} from './actions'

const indicators = handleActions({
  [indicatorResponse]: produce((draft, action) => {
    const { data, error, key } = action.payload
    draft[key] || (draft[key] = {})

    if (error) {
      console.error(error.message)
      draft[key].error = error.message
      draft[key].data = null
      return
    }

    if (data) {
      delete draft[key].error
      draft[key].data = data
    }
  })
}, {})

export * from './actions'
export * from './hooks'
export * from './selectors'

export default combineReducers({
  indicators
})
